module.exports = __webpack_public_path__ + "static/media/vvce.76693479.jpg";